/**
 * Created by richard on 7/14/14.
 */
var applicationsModel = angular.module('applicationsModel', ['schoolModel']);
applicationsModel.factory('ApplicationsModelFactory', function(ApplicationService, RestService, authServiceFactory, SchoolModelFactory){
    var ApplicationsModel = function(){
        this.endpoint = "/Applications";
        this.primaryKey = "schoolID";
    }
    ApplicationsModel.prototype = new SchoolModelFactory();
    ApplicationsModel.prototype.parent = SchoolModelFactory.prototype;
    ApplicationsModel.prototype.resolveData = function(schoolID)
    {
        var parent = this;
        return this.parent.resolveData.apply(this, arguments).then(function(data)
        {
            parent.data = data[0].data;
        });

    }
    return ApplicationsModel;
});


applicationsModel.service('ApplicationsModelService', function(ApplicationsModelFactory){
    var applicationsModel = new ApplicationsModelFactory();
    return applicationsModel;
});


